import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { Box, Button, FillTag, Text } from '@doda/io-react/common';
import { desiredCondSelector } from '@doda/common/src/redux/features/memberInfo';
import { useSetModal } from '../Layout';
import styles from './index.module.scss';
import { measureClickDesiredConditionSetting } from '../../logics/analytics';

/** 希望条件設定 */
export const DesiredCondSetting = () => {
  const dispatch = useAppDispatch();
  const desiredConditionsText =
    useAppSelector(desiredCondSelector) || '希望条件を設定してください';
  const setModal = useSetModal();

  const handleClickChange: DesiredCondSettingUIProps['onClickChange'] = () => {
    setModal(true);
    dispatch(measureClickDesiredConditionSetting);
  };

  return (
    <DesiredCondSettingUI
      desiredCond={desiredConditionsText}
      onClickChange={handleClickChange}
    />
  );
};

/** DesiredCondSettingUIコンポーネントのプロパティ */
interface DesiredCondSettingUIProps {
  /** 希望条件のテキスト */
  desiredCond: string;
  /** 条件変更ボタンがクリックされたときのイベントハンドラ */
  onClickChange: React.MouseEventHandler<HTMLButtonElement>;
}

/**
 * 希望条件設定UIコンポーネント
 *
 * @param {DesiredCondSettingUIProps} props - コンポーネントのプロパティ
 * @param {string} props.desiredCond - 希望条件のテキスト
 * @param {React.MouseEventHandler<HTMLButtonElement>} props.onClickChange - 条件変更ボタンがクリックされたときのイベントハンドラ
 * @returns {JSX.Element} - 希望条件設定UIコンポーネント
 */
export const DesiredCondSettingUI = (props: DesiredCondSettingUIProps) => {
  const { desiredCond, onClickChange } = props;
  return (
    <Box
      border="gray"
      color="white"
      radius="4"
      className={styles['matchJobList-desiredCondSetting__box']}
    >
      <FillTag
        color="lightGreen"
        className={styles['matchJobList-desiredCondSetting__tag']}
      >
        希望条件
      </FillTag>
      <Text
        as="p"
        color="gray"
        size="12"
        weight="normal"
        className={styles['matchJobList-desiredCondSetting__text']}
      >
        {desiredCond}
      </Text>
      <Button
        as="button"
        size="XS"
        variant="outline_gray"
        onClick={onClickChange}
        className={styles['matchJobList-desiredCondSetting__button']}
      >
        条件変更
      </Button>
    </Box>
  );
};
